import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from "@material-ui/icons/CloudDownload";
import DeleteIcon from "@material-ui/icons/Delete";


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const PayViaBankTransferTableComponentsForm = props => {
  const classes = useStyles();
  const { rows, columns, onDelete, onDownload, hideAction } = props;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell style={column.style} key={i}>{column.label}</TableCell>
            ))}
            {!hideAction && <TableCell style={{ width: '15%' }} align="center">Action</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell key={column.key} component="th" scope="row">
                  {column.key === "documentTypeLabel" ? "Bank Recipe" : row[column.key] || ''}
                </TableCell>
              ))}
              {!hideAction && <TableCell align="center">
                <IconButton onClick={() => onDelete(row.id)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => onDownload(row.fileName)}>
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </TableCell>
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {rows.length <= 0 && <Paper style={{
        display: 'flex',
        justifyContent: 'center',
        padding: 50
      }}>No Data</Paper>}
    </TableContainer >
  );
}

PayViaBankTransferTableComponentsForm.propTypes = {
  rows: PropTypes.array,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func,
  columns: PropTypes.array,
  hideAction: PropTypes.bool
};

PayViaBankTransferTableComponentsForm.defaultProps = {
  rows: [],
  columns: [],
  onDownload: fn => fn,
  onDelete: fn => fn,
  hideAction: false
};

export default PayViaBankTransferTableComponentsForm;